export default function MultiplesHeader({
  title,
  copy,
}: {
  title: string
  copy: string[]
}) {
  return (
    <div className="mb-5">
      <h4 className="text-white text-[36px] font-decimal mb-3">{title}</h4>
      {copy.map((line, index) => (
        <p key={index} className="text-white text-[18px] font-decimal mb-5">
          {line}
        </p>
      ))}
    </div>
  )
}
